import { render } from "./ChronosKairos.vue?vue&type=template&id=2704535d&scoped=true&ts=true"
import script from "./ChronosKairos.vue?vue&type=script&lang=ts"
export * from "./ChronosKairos.vue?vue&type=script&lang=ts"

import "./ChronosKairos.vue?vue&type=style&index=0&id=2704535d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2704535d"]])

export default __exports__